import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {
	GetBeneficiaryAddressValidationV4,
	GetBeneficiaryAddressValidationV4Params,
	GetBeneficiaryAddressValidationV4Response,
} from 'domain/usecases/private/profile/get-update-indicator';

export class RemoteGetUpdateIndicator implements GetBeneficiaryAddressValidationV4 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetBeneficiaryAddressValidationV4Response>,
	) {}

	async get({
		signal,
	}: GetBeneficiaryAddressValidationV4Params): Promise<GetBeneficiaryAddressValidationV4Response> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
